import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import {
  ContractPriceHistoryItemReadModel,
  ContractPriceListItemReadModel,
} from './types';

export const contractPricesApi = createApi({
  reducerPath: 'contractPricesApi',
  baseQuery: axiosBaseQuery({ baseUrl: Config.VITE_API_URL }),
  tagTypes: ['ContractPrices'],
  endpoints: builder => ({
    getActiveContractPricesI: builder.infiniteQuery<
      ContractPriceListItemReadModel[],
      { contractId: string } & FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg: { contractId, ...filters }, pageParam }) => ({
        url: `/contracts/${contractId}/prices/by-date/active`,
        method: 'GET',
        params: { ...pageParam, ...filters },
      }),
      providesTags: (_, __, { contractId }) => [
        { type: 'ContractPrices', id: contractId },
      ],
    }),
    getContractPriceHistoryI: builder.infiniteQuery<
      ContractPriceHistoryItemReadModel[],
      { contractId: string } & FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg: { contractId, ...filters }, pageParam }) => ({
        url: `/contracts/${contractId}/prices/history`,
        method: 'GET',
        params: { ...filters, ...pageParam },
      }),
      providesTags: (_, __, { contractId }) => [
        { type: 'ContractPrices', id: contractId },
      ],
    }),
  }),
});

export const useGetActiveContractPricesInfiniteQuery =
  normalizeInfiniteQueryData<ContractPriceListItemReadModel>(
    contractPricesApi.useGetActiveContractPricesIInfiniteQuery,
  );

export const useGetContractPriceHistoryInfiniteQuery =
  normalizeInfiniteQueryData<ContractPriceHistoryItemReadModel>(
    contractPricesApi.useGetContractPriceHistoryIInfiniteQuery,
  );
